<footer class="footer soft-footer-crystal fixed-bottom py-3"> 
    <!-- fixed-bottom -->
    <div class="container-fluid">
        <div class="row">
            <div class="col d-flex justify-content-end">
                <p class="mb-0 text-sm">© {{ current_year }} Spider Dashboard Angular</p>
            </div>
        </div>
    </div>
</footer>